import { CaptionsFrame } from 'captions/CaptionsFrame';
import { FrameData } from './FlyerData';
import { Frame } from './Frame';
import { FrameType } from './FrameType';
import { GradientFrame } from './GradientFrame';
import { PictureFrame } from './PictureFrame';
import { ShapeFrame } from './ShapeFrame';
import { SolidFrame } from './SolidFrame';
import { SoundWaveFrame } from './SoundWaveFrame';
import { TextFrame } from './TextFrame';

export const createFrameFromData = (
  data: FrameData,
  stageWidth: number,
  stageHeight: number
): Frame => {
  let frame: Frame | undefined = undefined;
  if (data.type) {
    switch (data.type) {
      case FrameType.Text:
        frame = new TextFrame(stageWidth, stageHeight);
        break;
      case FrameType.Captions:
        frame = new CaptionsFrame(stageWidth, stageHeight);
        break;
      case FrameType.SolidColor:
        frame = new SolidFrame(stageWidth, stageHeight);
        break;
      case FrameType.Gradient:
        frame = new GradientFrame(stageWidth, stageHeight);
        break;
      case FrameType.SoundWave:
        frame = new SoundWaveFrame(stageWidth, stageHeight);
        break;
      case FrameType.Shape:
        frame = new ShapeFrame(stageWidth, stageHeight);
        break;
      default:
        break;
    }
  }
  // console.log('CREATED FRAME: ' + frame?.type);
  if (!frame) {
    frame = new PictureFrame(stageWidth, stageHeight);
  }
  frame.populateWithData(data);
  if (data.id) {
    frame.id = data.id;
  }
  frame.relativeDuration = data.relativeDuration || 1;
  return frame;
};



// WEBPACK FOOTER //
// ./src/data/FrameUtils.ts